import { AxiosInstance } from 'axios';

import * as types from '../../../../../../typings/api/skymap/rest/v1/poi';
import { toUrlSearchParams } from './utils';

export class PoiServiceV1 implements types.Handlers {
  constructor(private axios: AxiosInstance) {}

  async associateImageWithPoi(params: types.AssociateImageWithPoiParameters): Promise<void> {
    await this.axios.post<types.AssociateImageWithPoiParameters>(
      `/v1/poi/${params.path.poiId}/images/${params.path.imageId}`,
    );
  }

  async removeAssociatedImageFromPoi(
    params: types.RemoveAssociatedImageFromPoiParameters,
  ): Promise<void> {
    await this.axios.delete<types.RemoveAssociatedImageFromPoiParameters>(
      `/v1/poi/${params.path.poiId}/images`,
    );
  }

  async associateTimelineContainerWithPoi(
    params: types.AssociateTimelineContainerWithPoiParameters,
  ): Promise<void> {
    await this.axios.post<types.AssociateTimelineContainerWithPoiParameters>(
      `/v1/poi/${params.path.poiId}/timeline-container/${params.path.timelineContainerId}`,
    );
  }

  async removeAssociatedTimelineContainerFromPoi(
    params: types.RemoveAssociatedTimelineContainerFromPoiParameters,
  ): Promise<void> {
    await this.axios.delete<types.RemoveAssociatedTimelineContainerFromPoiParameters>(
      `/v1/poi/${params.path.poiId}/timeline-container`,
    );
  }

  async patchPoi({ path, body }: types.PatchPoiParameters): Promise<types.PoiPatchResponse> {
    const { data } = await this.axios.patch(`/v1/poi/${path.poiId}`, body);

    return data;
  }

  async fetchPoi(params: types.FetchPoiParameters): Promise<types.PoiFetchResponse> {
    const { data } = await this.axios.get<types.PoiFetchResponse>(`/v1/poi/${params.path.poiId}`, {
      params: new URLSearchParams([...toUrlSearchParams('include', params.query.include)]),
    });
    return data;
  }

  async getPoiAssociateFiles({
    path,
  }: types.GetPoiAssociateFilesParameters): Promise<types.PoiGetFilesResponse> {
    const { data } = await this.axios.get(`/v1/poi/${path.poiId}/files`);

    return data;
  }

  async associateFilesWithPoi({
    path,
    body,
  }: types.AssociateFilesWithPoiParameters): Promise<void> {
    await this.axios.put(`/v1/poi/${path.poiId}/files`, body);
  }

  async associateAssetTagWithPoi(params: types.AssociateAssetTagWithPoiParameters): Promise<void> {
    await this.axios.post(`/v1/poi/${params.path.poiId}/asset-tags/${params.path.assetTagId}`);
  }

  async removeAssociatedAssetTagFromPoi(
    params: types.RemoveAssociatedAssetTagFromPoiParameters,
  ): Promise<void> {
    await this.axios.delete(`/v1/poi/${params.path.poiId}/asset-tags/${params.path.assetTagId}`);
  }

  async deletePoi(params: types.DeletePoiParameters): Promise<void> {
    await this.axios.delete(`/v1/poi/${params.path.poiId}`);
  }
}
